import { Badge } from '@algoacademy/design-system/web/data-display/Badge'
import { P3 } from '@algoacademy/design-system/web/typography/Paragraph'
import { cn } from '@/app/_lib/utils'

export enum ACCESS_TABS {
  VIEW = 'Przeglądający',
  MANAGE = 'Edytujący',
  ALL = 'Wszystkie typy dostępu'
}

type AccessTypeTabsProps = {
  activeTab: ACCESS_TABS
  onChange: (tab: ACCESS_TABS) => void
}

export function AccessTypeTabs({ activeTab, onChange }: AccessTypeTabsProps) {
  return (
    <div className='custom-scrollbar space-y-2'>
      <P3 className='text-contentSecondary'>Typ dostępu</P3>

      <div className='flex flex-wrap gap-2'>
        {Object.entries(ACCESS_TABS).map(([key, label]) => {
          const isActive = activeTab === label

          return (
            <Badge
              key={key}
              color={isActive ? 'blueInverted' : 'secondary'}
              className={cn(
                'cursor-pointer border px-3',
                isActive
                  ? 'border-contentBlue'
                  : 'border-borderSecondary hover:border-borderPrimary'
              )}
              onClick={() => onChange(label as ACCESS_TABS)}
            >
              {label}
            </Badge>
          )
        })}
      </div>
    </div>
  )
}
